import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "reserveForm"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "预约叫车", -1);
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "card select-day"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "h1"
}, "您想在什么时候出发？", -1);
const _hoisted_6 = {
  class: "day"
};
const _hoisted_7 = {
  class: "time-picker"
};
const _hoisted_8 = {
  class: "reserveTime"
};
const _hoisted_9 = {
  class: "reserve"
};
const _hoisted_10 = {
  class: "button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_van_time_picker = _resolveComponent("van-time-picker");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_radio_group, {
    modelValue: $data.selectReserveDay,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selectReserveDay = $event),
    direction: "horizontal"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_radio, {
      name: 0,
      "checked-color": "#ff8c00"
    }, {
      default: _withCtx(() => [_createTextVNode("今天")]),
      _: 1
    }), _createVNode(_component_van_radio, {
      name: 1,
      "checked-color": "#ff8c00"
    }, {
      default: _withCtx(() => [_createTextVNode("明天")]),
      _: 1
    }), _createVNode(_component_van_radio, {
      name: 2,
      "checked-color": "#ff8c00"
    }, {
      default: _withCtx(() => [_createTextVNode("后天")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_time_picker, {
    "show-toolbar": false,
    title: "选择时间",
    modelValue: $data.selectReserveTime,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.selectReserveTime = $event),
    "visible-option-num": 4,
    formatter: $options.reserveTimePickerFormatter,
    "min-hour": $data.dataReserveTimeMinHour,
    "min-minute": $data.dataReserveTimeMinMinute
  }, null, 8, ["modelValue", "formatter", "min-hour", "min-minute"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_van_icon, {
    name: require('@/assets/icon/menu/reserve.svg')
  }, null, 8, ["name"])]), _createTextVNode(" 您将预约 "), _createElementVNode("strong", null, [parseInt($data.selectReserveDay) === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(" 今天 ")], 64)) : _createCommentVNode("", true), parseInt($data.selectReserveDay) === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(" 明天 ")], 64)) : _createCommentVNode("", true), parseInt($data.selectReserveDay) === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createTextVNode(" 后天 ")], 64)) : _createCommentVNode("", true), _createTextVNode(" (" + _toDisplayString($options.CommonUtil.formatDay($data.selectReserveDay, "MM月DD日")) + ") " + _toDisplayString($data.selectReserveTime[0]) + "时" + _toDisplayString($data.selectReserveTime[1]) + "分 ", 1)]), _createTextVNode("出发 ")]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_button, {
    color: "#ff8c00",
    block: "",
    plain: "",
    onClick: $options.nowButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 现在出发 ")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_van_button, {
    color: "#ff9500",
    block: "",
    onClick: $options.reserveButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 预约出发 ")]),
    _: 1
  }, 8, ["onClick"])])])]);
}